import { intersection, difference } from 'lodash'

export default function (array1, array2) {
	const result = {
		matched: intersection(array1, array2),
		missingRight: difference(array1, array2),
		missingLeft: difference(array2, array1)
	}
	return result
}